import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { sortNews } from "./news-utils"

const PLACEHOLDER_IMG = '/news-placeholder.png'

export default function News() {
    const [items, setItems] = useState([])
    const [error, setError] = useState('')
    const [page, setPage] = useState(0)
    const postsPerPage = 5

    useEffect(() => {
        (async () => {
            try {
                const res = await fetch('/news.json', { cache: "no-store"})
                if (!res.ok) throw new Error(`HTTP ${res.status}`)

                const data = await res.json()
                const sorted = sortNews(data)
                const filtered = sorted.filter((post) => post.display !== false)
                setItems(filtered)
            } catch (e) {
                 setError("Sikertelen betöltés")
                console.error(e)
            }
        })()
    }, [])

    useEffect(() => {
        if (!items) return
        const totalPages = Math.max(1, Math.ceil(items.length / postsPerPage))
        if (page > totalPages - 1) setPage(totalPages - 1)
    }, [items])

    const totalPages = Math.max(1, Math.ceil(items.length / postsPerPage))
    const start = page * postsPerPage
    const end = start + postsPerPage
    const pageItems = items.slice(start, end)

    return (
        <>
        <h1 class='text-center mx-auto lg:py-[50px] uppercase text-[20px] sm:text-[28px] lg:text-[40px] font-bold text-bja-secondary tracking-wider'>Hírek</h1>
        <div class='bg-white sm:px-[20px] lg:px-[50px] py-[20px] md:py-[20px] lg:py-[50px] gap-[20px] md:gap-[50px] flex flex-col'>
            <div class='flex flex-col'>
                {
                    pageItems.length > 0 ? (
                        pageItems.map((post) => {

                            return (
                                <div key={post.id} class={`mx-auto max-w-[1600px] w-full max-h-[450px] h-full flex md:odd:flex-row md:even:flex-row-reverse flex-col`}>
                                    <img src={post.image ?? PLACEHOLDER_IMG} class='md:w-1/2 h-[250px] md:h-auto overflow-hidden object-cover' />

                                    <div class='md:w-1/2 flex flex-col gap-[15px] lg:gap-[30px] items-center p-[20px] md:p-[50px]'>
                                        <h2 class='text-[20px] md:text-[24px] lg:text-[28px] xl:text-[32px] line-clamp-2 text-bja-secondary small-caps text-center font-semibold'>{post.title}</h2>
                                        <div class='flex items-center w-full'>
                                            <div class='flex-grow border-t border-bja-primary'></div>
                                            <span class='mx-2 text-bja-primary small-caps text-sm md:text-base'>{post.date.slice(0, 10)} | {post.tags[0]}</span>
                                            <div class='flex-grow border-t border-bja-primary'></div>
                                        </div>
                                        <p class='news-content text-justify w-full overflow-hidden text-ellipsis line-clamp-4 md:line-clamp-6 lg:line-clamp-4' >{post.text}</p>
                                        <Link to={`/hirek/poszt/${post.id}`} class='bg-bja-primary text-white font-bold sm:text-[16px] lg:drop-shadow-secondary-lg lg:px-[25px] lg:py-[15px] drop-shadow-secondary-sm px-[15px] py-[5px] text-[14px] text-bold uppercase w-fit self-center hover:bg-bja-secondary hover:drop-shadow-primary-sm lg:hover:drop-shadow-primary-lg hover:text-white' >Elolvasom</Link>

                                    </div>
                                </div>
                            )
                        })
                    ) : (
                        <p class='text-black'>Hírek betöltése...</p>
                    )
                }

            </div>
            <div class='self-center flex gap-[20px] md:gap-[50px]'>
                {page >= 1 && <Link onClick={() => setPage(p => Math.max(0, p-1))} class={`bg-bja-primary text-white font-bold sm:text-[16px] lg:drop-shadow-secondary-lg lg:px-[25px] lg:py-[15px] drop-shadow-secondary-sm px-[15px] py-[5px] text-[14px] text-bold uppercase w-fit self-center hover:bg-bja-secondary hover:drop-shadow-primary-sm lg:hover:drop-shadow-primary-lg hover:text-white`}><FontAwesomeIcon icon={faArrowLeft} /></Link>}
                {page < totalPages - 1 && <Link onClick={() => setPage(p => Math.min(totalPages - 1, p + 1))} class={`bg-bja-primary text-white font-bold sm:text-[16px] lg:drop-shadow-secondary-lg lg:px-[25px] lg:py-[15px] drop-shadow-secondary-sm px-[15px] py-[5px] text-[14px] text-bold uppercase w-fit self-center hover:bg-bja-secondary hover:drop-shadow-primary-sm lg:hover:drop-shadow-primary-lg hover:text-white `}><FontAwesomeIcon icon={faArrowRight} /></Link>}

            </div>
        </div>
        </>
    )
}